import 'devextreme/dist/css/dx.light.css';
import { createTheme, ThemeProvider } from '@mui/material'
import { useState } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Login from './pages/Authentication/Login'
import SharedLayout from './pages/Layout/SharedLayout'
import Profile from './pages/Profile/Profile'
import ErrorPage from './pages/Error/ErrorPage'
import WaitingPage from './pages/Error/WaitingPage'
import Register from './pages/Authentication/Register'
import RequireAuth from './pages/Layout/RequireAuth'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'
import RegisterSupplier from './pages/Authentication/RegisterSupplier'
import ForgetPassword from './pages/Authentication/ForgetPassword'
import ChangePassword from './pages/Authentication/ChangePassword'
import BIDsComparison from './pages/Procurement/BidComparsionChart/BIDsComparison'
import BIDsCard from './pages/Procurement/BIDs/BIDsCard'
import BIDsCardCompany from './pages/Procurement/BIDs/BIDsCardCompany'
import SupplierEvaluation from './pages/SupplierEvaluation/SupplierEvaluation'
import VendorCard from './pages/Vendor/VendorCard'
import './i18n'
import Dashboard from './pages/Dashboard/Dashboard'
import BidCard from './pages/Procurement/BidComparsionChart/bidCard'
import ResetPassword from './pages/Authentication/ResetPassword'
import NotAccessPage from './pages/Error/NotAccessPage';
import 'devexpress-dashboard/dist/css/dx-dashboard.light.css';
import '@devexpress/analytics-core/dist/css/dx-analytics.common.css';
import '@devexpress/analytics-core/dist/css/dx-analytics.light.css';
import '@devexpress/analytics-core/dist/css/dx-querybuilder.css';
import 'devexpress-reporting/dist/css/dx-webdocumentviewer.css';
import 'devexpress-reporting/dist/css/dx-reportdesigner.css';
import AccessDeniedVendor from './pages/Error/AccessDeniedVendor';
import Vendor from './pages/Vendor/Vendor';
import RfqInformation from './pages/Procurement/RfqInformation/RfqInformation';
import UserCard from './pages/UserManager/User/UserCard';
import User from './pages/UserManager/User/User';
import MsLogin from './pages/Authentication/MsLogin'
import IndividualVendor from './pages/SupplierEvaluation/IndividualVendor/IndividualVendor';

function App() {
    const [mode, setMode] = useState('light')

    const darkTheme = createTheme({
        palette: {
            mode: mode,
        },
    })



    return (
        <>
            <ThemeProvider theme={darkTheme}>
                <BrowserRouter>
                    <Routes>
                        <Route element={<RequireAuth />}>
                            <Route element={<SharedLayout setMode={setMode} mode={mode} />}>
                                <Route path="/" element={<Dashboard />} />

                                {/* BIDs */}
                                <Route path="bids/:dataId" element={<BIDsCard />} />
                                <Route path="bid-card-company" element={<BIDsCardCompany />} />

                                <Route path="bid-comparison" element={<BIDsComparison />} />
                                <Route path="bid-comparison/:dataId" element={<BidCard />} />

                                {/*Vendor */}
                                <Route path="/vendors" element={<Vendor />} />
                                <Route path="/vendors/:dataId" element={<VendorCard />} />

                                <Route path="rfq-information" element={<RfqInformation />} />

                                <Route path="users" element={<User />} />
                                <Route path="user/:dataId" element={<UserCard />} />

                                <Route path="profile" element={<Profile />} />

                            </Route>
                        </Route>
              

                        {/*Evaulation From */}
                        <Route path="supplier-evaluation" element={<SupplierEvaluation />} />
                        <Route path="supplier-evaluation/:dataId" element={<SupplierEvaluation />} />
                        <Route path="individual-vendor" element={<IndividualVendor />} />

                        {/* Authentication */}
                        <Route index path="login" element={<Login />} />
                        <Route path="/login/microsoft/oauth2/code/azure-client" element={<MsLogin />} />
                        <Route path="register" element={<Register />} />
                        <Route path="register-supplier" element={<RegisterSupplier />} />
                        <Route path="forget-password" element={<ForgetPassword />} />
                        <Route path="reset-password" element={<ResetPassword />} />
                        <Route path="change-password" element={<ChangePassword />} />
                        <Route path="*" element={<ErrorPage />} />
                        <Route path="waiting" element={<WaitingPage />} />
                        <Route path="not-access" element={<NotAccessPage />} />
                        <Route path="403" element={< AccessDeniedVendor />} />

                    </Routes>
                </BrowserRouter>
            </ThemeProvider>
            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                progress={undefined}
            />
        </>
    )
}

export default App